import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

export const CustomLoader = ({loading}) => {
  return (
    <>
      {loading && (
      <Box
        sx={{
          position: 'fixed',  
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.3)',
          zIndex: 9999, 
        }}
      >
        <CircularProgress color="inherit" />
      </Box>
    )}
    </>
  )
}
